import { MixpanelContext } from '@providers';
import { useContext } from 'react';

const useMixpanel = () => useContext(MixpanelContext);

export default useMixpanel;
